import { Action } from 'redux';
import { Application } from '../../clients/aasServerClient.generated';

export enum ActionTypeNames {
    FetchTableApplications = 'Applications/FetchTableApplications',
    FetchTableApplicationsNF = 'Applications/FetchTableApplicationsNF',
    StoreTableApplications = 'Applications/StoreTableApplications',

    FetchAllApplications = 'Applications/FetchAllApplications',
    StoreAllApplications = 'Applications/StoreAllApplications',

    ClearSingleApplication = 'Applications/ClearSingleApplication',
    FetchSingleApplication = 'Applications/FetchSingleApplication',
    NewSingleApplication = 'Applications/NewSingleApplication',
    CopySingleApplication = 'Applications/CopySingleApplication',
    StoreSingleApplication = 'Applications/StoreSingleApplication',
    CreateSingleApplication = 'Applications/CreateSingleApplication',
    SaveSingleApplication = 'Applications/SaveSingleApplication',
    SavedSingleApplication = 'Applications/SavedSingleApplication',

    DeleteApplications = 'Applications/DeleteApplications',
    AssignApplicationsWorkspace = 'Applications/AssignApplicationsWorkspace',
    SynchronizeUsers = 'Applications/SynchronizeUsers',
}

export type ApplicationsAction<T extends ActionTypeNames> = Action<T> & {
    applicationIds: string[];
};

export type FetchTableApplicationsAction = Action<ActionTypeNames.FetchTableApplications>;
export type FetchTableApplicationsNFAction = Action<ActionTypeNames.FetchTableApplicationsNF>;

export type StoreTableApplicationsAction = Action<ActionTypeNames.StoreTableApplications> & {
    applications: Application[]
};

export type FetchAllApplicationsAction = Action<ActionTypeNames.FetchAllApplications>;
export type StoreAllApplicationsAction = Action<ActionTypeNames.StoreAllApplications> & {
    applications: Application[]
};

export type DeleteApplicationsAction = ApplicationsAction<ActionTypeNames.DeleteApplications>;
export type AssignApplicationsWorkspaceAction = ApplicationsAction<ActionTypeNames.AssignApplicationsWorkspace> & {
    workspaceId: string;
};

export type FetchSingleApplicationAction = Action<ActionTypeNames.FetchSingleApplication> & {
    id: string;
};
export type NewSingleApplicationAction = Action<ActionTypeNames.NewSingleApplication>;
export type CopySingleApplicationAction = Action<ActionTypeNames.CopySingleApplication> & {
    id: string;
};
export type StoreSingleApplicationAction = Action<ActionTypeNames.StoreSingleApplication> & {
    application: Partial<Application>;
};
export type SaveSingleApplicationAction = Action<ActionTypeNames.SaveSingleApplication> & {
    application: Partial<Application>;
    workspaceId?: string;
    serverId?: string;
};

export type CreateSingleApplicationAction = Action<ActionTypeNames.CreateSingleApplication> & {
    application: Partial<Application>;
    workspaceId?: string;
    serverId?: string;
};

export type ClearSingleApplicationAction = Action<ActionTypeNames.ClearSingleApplication>;
export type SavedSingleApplicationAction = Action<ActionTypeNames.SavedSingleApplication>;

export type SynchronizeUsersAction = ApplicationsAction<ActionTypeNames.SynchronizeUsers>;
